import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

// -----------------------------------------------------------------
// SERVICES
// -----------------------------------------------------------------
import { ValidatorService } from '../../../services/validators/validator.service';

// -----------------------------------------------------------------
// COMPONENTS/COMPONENTES
// -----------------------------------------------------------------
import { ModalRestorePasswordComponent } from '../restore-password/restore-password.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-modal-login',
    templateUrl: './modal-login.component.html',
    styleUrls: ['./modal-login.component.scss']
})
export class ModalLoginComponent implements OnInit {

    // -----------------------------------------------------------------
    // ATTRIBUTES
    // -----------------------------------------------------------------
    form: FormGroup;
    validationFailed: boolean = false;

    // -----------------------------------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------------------------------
    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<ModalLoginComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        private customValidator: ValidatorService,
        private router: Router,
        private dialog: MatDialog
    ) { 
        this.validationFailed = data.isLoginValidationFailed;        
    }

    ngOnInit() {
        this.form = this.fb.group({
            mail: ['', [
                Validators.required,
                this.customValidator.validateEmail.bind(this),
                Validators.minLength(4).bind(this)
            ]],
            password: ['', [
                Validators.required,
                Validators.minLength(8).bind(this)
            ]]
        })
    }

    onLogin() {
        if (this.form.valid) {
            this.dialogRef.close(this.form.value);
        }
    }

    closeModal() {
        this.dialogRef.close(null)
    }

    goToMap()
    {
        this.closeModal();
        this.router.navigate(['/mapa']);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/modal-login/modal-login.component.ts